// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\App\Users\Tenant\Roles\Enums\TenantRoleField
// Generated on: <normalized>

export enum TenantRoleField {
  DB_TABLE = 'tenant_roles',
  DB_IDENTIFIER = 'roleGUID',
  NAME = 'name',
  PARENT_ROLE_GUID = 'parentRoleGUID',
  DESCRIPTION = 'description',
  CREATED_BY_USER_GUID = 'createdByUserGUID',
}

export const TenantRoleFieldWritableFields = ["name", "parentRoleGUID", "description"] as const;

export const TenantRoleFieldGetEncryptionFields = [] as const;

export const TenantRoleFieldCases = ["tenant_roles", "roleGUID", "name", "parentRoleGUID", "description", "createdByUserGUID"] as const;
